export const logout = ({commit}) => {
    commit("clearContext");
    commit("logout");
};


// WEBPACK FOOTER //
// ./src/store/actions/login.js